"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processedUrl = exports.canServe = void 0;

const append_params_to_url_1 = __importDefault(require("./append_params_to_url"));

const canServe = function (url, options) {
  if (options.metadata) return false;
  const isUnsplashUrl = !!url.startsWith('https://images.unsplash.com');
  return isUnsplashUrl;
};

exports.canServe = canServe;

const cropToFitMap = function (crop = 'limit') {
  const simpleMap = {
    fill: 'crop',
    lfill: 'min',
    limit: 'max',
    scale: 'scale',
    fit: 'clip',
    thumb: 'crop'
  };
  return simpleMap[crop];
};

const gravityToCropMap = function (gravity = 'auto') {
  const simpleMap = {
    north: 'top',
    center: 'center',
    auto: 'faces,edges'
  };
  return simpleMap[gravity];
};

const processedUrl = (url, options = {}) => {
  if (!url) {
    console.info('[vivaldi-client] url is null/undefined');
    url = '';
  }

  const processingOptions = []; // please keep these alphabetical. Yes, we can sort them using the sort function,
  // but it is also easier to follow for the devs.
  // aspect ratio

  if (options.ar) {
    processingOptions.push(['ar', options.ar.toString()]);
  }

  if (!options.format) {
    processingOptions.push(['auto', 'format']);
  } // blur


  if (options.effect && options.effect.startsWith('blur')) {
    const _options$effect$split = options.effect.split(':'),
          _options$effect$split2 = _slicedToArray(_options$effect$split, 2),
          _blur = _options$effect$split2[0],
          blurValue = _options$effect$split2[1]; // Whatever our internal system uses for blur is different from imgix.
    // Playing by the eye, our blur is about 9 times more powerful.


    const imgixBlurValue = parseInt(blurValue, 10) * 9;
    processingOptions.push(['blur', imgixBlurValue.toString()]);
  } else if (options.blur) {
    const imgixBlurValue = options.blur * 9;
    processingOptions.push(['blur', imgixBlurValue.toString()]);
  } // gravity / crop


  if (options.gravity) {
    processingOptions.push(['crop', gravityToCropMap(options.gravity)]);
  } else {
    processingOptions.push(['crop', gravityToCropMap('auto')]);
  } // crop


  if (options.width || options.height) {
    // dpr
    processingOptions.push(['dpr', (options.dpr || '2').toString()]); // fit

    processingOptions.push(['fit', cropToFitMap(options.crop)]);
  } // format


  if (options.format) {
    processingOptions.push(['fm', options.format]);
  } // height


  if (options.height) {
    const intHeight = Math.ceil(options.height);
    processingOptions.push(['h', intHeight.toString()]);
  } // quality


  if (options.quality) {
    processingOptions.push(['q', options.quality]);
  } // trim


  if (options.effect === 'trim' || options.trim) {
    processingOptions.push(['trim', 'auto']);
  } // width


  if (options.width) {
    const intWidth = Math.ceil(options.width);
    processingOptions.push(['w', intWidth.toString()]);
  }

  return append_params_to_url_1.default(url, processingOptions);
};

exports.processedUrl = processedUrl;